import { z } from 'zod'
import { dateValueSchema } from './date-value'

export const fileCommonSchema = z.object({
  /** 檔案 Id */
  fileId: z.string(),
  /** 名稱 */
  name: z.string(),
  /** 上傳人員 */
  uploadBy: z.string(),
  /** 上傳時間 */
  uploadTime: dateValueSchema
})

export interface FileCommon extends z.infer<typeof fileCommonSchema> {}
